import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { LimitedMember } from '../models/limited-member';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-checkin-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="avatar" aria-hidden="true"><span>{{ initials }}</span><img *ngIf="url" [src]="url" alt="" width="36" height="36" loading="lazy" decoding="async" (error)="url = ''"></span>`,
  styles: [`.avatar{display:inline-flex;position:relative;width:36px;height:36px;vertical-align:middle;align-items:center;justify-content:center;border-radius:50%;overflow:hidden;background:var(--church-accent,#d7e9fb);color:var(--church-text,#263746);margin-inline-end:8px;font-size:.8rem;font-weight:600;flex-shrink:0}.avatar img{position:absolute;inset:0;object-fit:cover}`]
})
export class CheckinAvatarComponent implements OnChanges {
  private static scope = '';
  private static urls = new Map<number, { url: string; expires: number }>();
  @Input() member: LimitedMember;
  url = '';
  initials = '';
  constructor(private http: HttpClient) {}
  ngOnChanges(): void {
    const member = this.member;
    this.url = '';
    this.initials = ((member?.firstName?.[0] || '') + (member?.lastName?.[0] || '')).toUpperCase();
    if (!member?.hasPicture) return;
    const scope = `${localStorage.getItem('tenant')}:${localStorage.getItem('CSBarcodeID')}`;
    if (CheckinAvatarComponent.scope !== scope) {
      CheckinAvatarComponent.urls.clear();
      CheckinAvatarComponent.scope = scope;
    }
    const cached = CheckinAvatarComponent.urls.get(member.id);
    if (cached && cached.expires > Date.now()) { this.url = cached.url; return; }
    // Resolve images independently; member selection never waits for S3 metadata.
    this.http.post<string>(`${environment.apiHost}/File/GetURL?Folder=profilepics&ObjectKey=${member.id}`, {}).subscribe({
      next: url => {
        if (url && CheckinAvatarComponent.scope === scope) CheckinAvatarComponent.urls.set(member.id, { url, expires: Date.now() + 10 * 60 * 1000 });
        if (this.member === member) this.url = url || '';
      },
      error: () => { /* Keep initials on unavailable photos. */ }
    });
  }
}
